import { Typography, useTheme } from '@material-ui/core'
import { LockOpenOutlined } from '@material-ui/icons'
import { SchoolPersonFragment } from '../../graphql/autogenerate/operations'
import { useCommonStyles } from '../../styles'
import { useModal } from '../modal'

type Props = {
  modal: ReturnType<typeof useModal>
  schoolPersonToEdit: SchoolPersonFragment
  schoolName: string
}
const ActiveAccount = ({ schoolPersonToEdit, schoolName, modal }: Props) => {
  const commonStyles = useCommonStyles()
  const theme = useTheme()

  return (
    <div>
      <Typography gutterBottom variant="h6">
        Their account is set up and good to go!
      </Typography>

      <Typography style={{ marginBottom: theme.spacing(2), display: 'flex', alignItems: 'center' }}>
        You can manage {schoolPersonToEdit.person?.firstName}'s permissions by pressing the{' '}
        <LockOpenOutlined
          style={{ margin: `0px ${theme.spacing(0.5)}px ${theme.spacing(0.5)}` }}
          className={commonStyles.baseIconColor}
        />{' '}
        icon.
      </Typography>
    </div>
  )
}

export default ActiveAccount
